// Texty detailu značky (brandDetail.js).
export default {
  /** „N produktů skladem" — N je reálný počet z nativního filtru dostupnosti */
  stockLabel: (n) => n + ' produktů skladem',
  chipService: 'Servis a náhradní díly',
  chipWarranty: 'Záruka 24 měsíců',
  serviceEyebrow: 'Servis značky',
  /** „Díly <značka> skladem" */
  serviceTitlePre: 'Díly ',
  serviceTitlePost: ' skladem',
  serviceText: 'Baterie, nabíječky i běžné náhradní díly řešíme na prodejně v Bílině.',
  serviceCta: 'Servis nářadí',
};
